import { createElement } from "@/utils/create-elem.js";
import { cells } from "./cells.js";
import { tips } from "./tips.js";
import "@/styles/components/board.scss";

export function Board(parent) {
  const board = createElement({
    tag: "div",
    id: "board",

    classes: ["board"],
    parent: parent,
  });
  createElement({
    tag: "div",
    classes: ["empty", "board__item"],
    parent: board,
  });

  tips(board);
  cells(board);
}
